import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  root: {
    width: 540,
    padding: theme.spacing(3),
  },
  header: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    color: grey[600],
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  description: {
    fontSize: 16,
    paddingTop: theme.spacing(2),
    lineHeight: 2,
  },
}));
